// the distinction here from RadioButtonGroup is that the children here can be anything
// <input>s in RadioButtonGroup cannot have children
// but this component can have children and utilizes aria
// and some conventions to implement the radio group functionality
// design pattern for aria-compliant radio group and radio
// https://www.w3.org/TR/2016/WD-wai-aria-practices-1.1-20160317/examples/radio/radio.html
// other controls:
// https://www.w3.org/TR/wai-aria-practices-1.1/
import cx from 'classnames';
import React, {
  Children, cloneElement,
} from 'react';
import PropTypes from 'prop-types';

import Radio from '../Radio';

import './RadioGroup.scss';

// Left: 37
// Up: 38
// Right: 39
// Down: 40
const onKeyDown = (e) => {
  let elementToFocus;
  let dir;

  if (e.keyCode === 39 || e.keyCode === 40) {
    dir = 'advance';
  } else if (e.keyCode === 37 || e.keyCode === 38) {
    dir = 'regress';
  }

  switch (dir) {
    case ('advance'):
      if (e.currentTarget.nextSibling) {
        elementToFocus = e.currentTarget.nextSibling;
      } else if (e.currentTarget === e.currentTarget.parentElement.lastElementChild) {
        elementToFocus = e.currentTarget.parentElement.firstElementChild;
      }

      if (elementToFocus) {
        elementToFocus.focus();
      }
      break;

    case ('regress'):
      if (e.currentTarget.previousSibling) {
        elementToFocus = e.currentTarget.previousSibling;
      } else if (e.currentTarget === e.currentTarget.parentElement.firstElementChild) {
        elementToFocus = e.currentTarget.parentElement.lastElementChild;
      }

      if (elementToFocus) {
        elementToFocus.focus();
      }
      break;

    default:
  }
};

const RadioGroup = ({
  children, className, onChange, ...props
}) => {
  const getOnFocus = (val) => () => {
    onChange(val);
  };

  return (
    <div role="radiogroup" className={cx('RadioGroup', className)} {...props}>
      {Children.map(
        children,
        (child) => cloneElement(child, { onKeyDown, onFocus: getOnFocus(child.props.value) })
      )}
    </div>
  );
};

RadioGroup.propTypes = {
  children: PropTypes.arrayOf(Radio).isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

RadioGroup.defaultProps = {
  className: null,
};

RadioGroup.displayName = 'RadioGroup';
export { onKeyDown };
export default RadioGroup;
